import { useIntl } from 'react-intl';

import { notesSectionMessages } from './notes-section-messages';
import styles from './NotesSection.module.css';
import { DetailSection } from '../detail-section/DetailSection';

import type { OrderNote } from '../../freight-details-types';

type NotesSectionProps = {
  notes?: OrderNote[];
};

/**
 * Read-only Notes card for the freight details view. The host decides which notes appear, in what
 * order, and what each one is labeled. Renders nothing at all when there are no notes — most
 * freight shipments have none, and an empty card is just noise in the column.
 * Store-agnostic — all data arrives via props.
 */
export const NotesSection = ({ notes }: NotesSectionProps) => {
  const intl = useIntl();

  if (!notes?.length) return null;

  return (
    <DetailSection testId='notes-section' title={intl.formatMessage(notesSectionMessages.sectionTitle)}>
      <div className={styles.rows}>
        {notes.map((note) => (
          <div className={styles.row} key={note.label}>
            <span className={styles.label}>{note.label}</span>
            <span className={styles.body}>{note.body}</span>
          </div>
        ))}
      </div>
    </DetailSection>
  );
};
